import notificationsServices from "src/api-services/notifications-services";
import { showResponseMessage } from "src/Components/utils/handellApiResponse";

export const createNotificationsSlice = (set,get) => ({
  notifications: [],
  notificationsLoading: false,
  notification: {},
  notificationLoading: false,
  fetchNotificationsFunction: async () => {
    set({ notificationsLoading: true });
    try {
      const response = await notificationsServices.getNotifications();
      set({
        notifications: response.data.data,
        notificationsLoading: false,
      });
    } catch (error) {
      set({ notificationsLoading: false });
    }
  },

  createNotificationFunction: async (data) => {
    set({ notificationLoading: true });
    try {
      const response = await showResponseMessage(
        notificationsServices.createNotification(data),
        "store"
      );
      set({
        notifications: [...get().notifications, response.data.data],
        notificationLoading: false,
      });
    } catch (error) {
      set({ notificationLoading: false });
    }
  },
  updateNotificationFunction: async ( data) => {
    set({ notificationLoading: true });
    try {
      const response = await showResponseMessage(
        notificationsServices.updateNotification(data),
        "update"
      );
      const newNotifications = get().notifications.map((notification) => {
        if (notification.id === data.id) {
          return response.data.data;
        }
        return notification;
      });
      set({ notifications: newNotifications, notificationLoading: false });
    } catch (error) {
      set({ notificationLoading: false });
    }
  },
  deleteNotificationFunction: async (id) => {
    set({ notificationLoading: true });
    try {
      const response = await showResponseMessage(
        notificationsServices.deleteNotification(id),
        "delete"
      );
      const newNotifications = get().notifications.filter(
        (notification) => notification.id !== id
      );
      
      set({ notifications: newNotifications, notificationLoading: false });
    } catch (error) {
      set({ notificationLoading: false });
    }
  },
  publishNotificationFunction: async (id, target) => {
    set({ notificationLoading: true });
    try {
      const response = await showResponseMessage(
        notificationsServices.PublishNotification(id, target),
        "publish"
      );
      set({ notificationLoading: false });
      return response;
    } catch (error) {
      set({ notificationLoading: false });
      throw error;
    }
  },
  ////////////////////////////////////////////////////////////////////////
  setNotification: (notification) => set({ notification }),
  fetchNotificationFunction: async (id) => {
    set({ notificationLoading: true });
    try {
      const response = await notificationsServices.getNotification(id);
      set({
        notification: response.data.data,
        notificationLoading: false,
      });
    } catch (error) {
      set({ notificationLoading: false });
    }
  },
});
